import React, {useState} from 'react' 
import AuthorList from '../AuthorList/AuthorList'
import GlobeSection from '../GlobeSection/GlobeSection'
import ReactTooltip from "react-tooltip";
import MapSection from '../MapSection/MapSection';
import StanceTable from '../StanceTable/StanceTable';
import { Link } from 'react-router-dom';

function Home() {
  const [content, setContent] = useState("");
  const [isActive, setIsActive] = useState(false);

  const centralBankPins = [
    { name: "FOMC", fullName: "Federal Open Market Committee",            lat:  38.89278, lng:  -77.04583, countryCode: "USA", sentences: 47330 },
    { name: "PBoC", fullName: "People's Bank of China",                    lat:  39.90667, lng:  116.35389, countryCode: "CHN", sentences:  1189 },
    { name: "BoJ",  fullName: "Bank of Japan",                             lat:  35.68610, lng:  139.77150, countryCode: "JPN", sentences: 67821 },
    { name: "BoE",  fullName: "Bank of England",                           lat:  51.51420, lng:   -0.08850, countryCode: "GBR", sentences: 68020 },
    { name: "SNB",  fullName: "Swiss National Bank",                       lat:  47.36865, lng:    8.53918, countryCode: "CHE", sentences:  3390 },
    { name: "BCB",  fullName: "Banco Central do Brasil",                   lat: -15.80306, lng:  -47.88556, countryCode: "BRA", sentences: 11588 },
    { name: "RBI",  fullName: "Reserve Bank of India",                     lat:  18.93324, lng:   72.83646, countryCode: "IND", sentences: 11102 },
    { name: "ECB", fullName: "European Central Bank", lat: 50.1089, lng: 8.7034, countryCode: "DEU", sentences: 21044 },
    { name: "CBR",  fullName: "Central Bank of Russia",                    lat:  55.76306, lng:   37.62139, countryCode: "RUS", sentences:  3430 },
    { name: "CBCT",  fullName: "Central Bank of (Taiwan)",                  lat:  25.10550, lng:  121.59737, countryCode: "TWN", sentences:  5149 },
    { name: "MAS",  fullName: "Monetary Authority of Singapore",           lat:   1.28027, lng:  103.85049, countryCode: "SGP", sentences:  2183 },
    { name: "BoK",  fullName: "Bank of Korea",                             lat:  37.56200, lng:  126.98066, countryCode: "KOR", sentences: 11084 },
    { name: "RBA",  fullName: "Reserve Bank of Australia",                 lat: -33.86820, lng:  151.21170, countryCode: "AUS", sentences: 25544 },
    { name: "BoI",  fullName: "Bank of Israel",                            lat:  31.78330, lng:   35.21670, countryCode: "ISR", sentences: 12994 },
    { name: "BoC",  fullName: "Bank of Canada",                            lat:  45.42088, lng:  -75.70297, countryCode: "CAN", sentences:  1499 },
    { name: "BdeM",  fullName: "Bank of Mexico",                            lat:  19.43261, lng:  -99.13321, countryCode: "MEX", sentences: 14290 },
    { name: "NBP",  fullName: "Narodowy Bank Polski",                      lat:  52.22968, lng:   21.01223, countryCode: "POL", sentences: 11388 },
    { name: "CBRT", fullName: "Central Bank of the Republic of Turkey",    lat:  39.92077, lng:   32.85411, countryCode: "TUR", sentences:  9801 },
    { name: "BoT",  fullName: "Bank of Thailand",                          lat:  13.75633, lng:  100.50177, countryCode: "THA", sentences:  7728 },
    { name: "CBE",  fullName: "Central Bank of Egypt",                     lat:  30.04442, lng:   31.23571, countryCode: "EGY", sentences:  2218 },
    { name: "BNM",  fullName: "Bank Negara Malaysia",                      lat:   3.13900, lng:  101.68686, countryCode: "MYS", sentences:  2344 },
    { name: "BSP",  fullName: "Bangko Sentral ng Pilipinas",              lat:  14.59950, lng:  120.98420, countryCode: "PHL", sentences: 15697 },
    { name: "CBoC", fullName: "Central Bank of Chile",                    lat: -33.44890, lng:  -70.66930, countryCode: "CHL", sentences:  3560 },
    { name: "BCRP", fullName: "Central Reserve Bank of Peru",              lat: -12.04640, lng:  -77.04280, countryCode: "PER", sentences:  4199 },
    { name: "BanRep", fullName: "Banco de la República (Colombia)",       lat:   4.71100, lng:  -74.07210, countryCode: "COL", sentences:  9461 }
  ];  

  const BANKS = [
    { abbr: 'FOMC', href: '/fomc' },
    { abbr: 'PBoC', href: '/pboc' },
    { abbr: 'BoJ',  href: '/boj' },
    { abbr: 'BoE',  href: '/boe' },
    { abbr: 'SNB',  href: '/snb' },
    { abbr: 'BCB',  href: '/bcb' },
    { abbr: 'RBI',  href: '/rbi' },
    { abbr: 'ECB',  href: '/ecb' },
    { abbr: 'CBR',  href: '/cbr' },
    { abbr: 'CBCT', href: '/cbct' },
    { abbr: 'MAS',  href: '/mas' },
    { abbr: 'BoK',  href: '/bok' },
    { abbr: 'RBA',  href: '/rba' },
    { abbr: 'BoI',  href: '/boi' },
    { abbr: 'BoC',  href: '/boc' },
    { abbr: 'BdeM', href: '/bdem' },
    { abbr: 'NBP',  href: '/nbp' },
    { abbr: 'CBRT', href: '/cbrt' },
    { abbr: 'BoT',  href: '/bot' },
    { abbr: 'CBE',  href: '/cbe' },
    { abbr: 'BNM',  href: '/bnm' },
    { abbr: 'BSP',  href: '/bsp' },
    { abbr: 'CBoC', href: '/cboc' },
    { abbr: 'BCRP', href: '/bcrp' },
    { abbr: 'BanRep', href: '/banrep' },
  ];
  
  console.error = () => {}; 

  return (
    <div className="">
<nav className="navbar is-spaced" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <Link to="/" className="navbar-item">
          <img src="/static/images/logo2.png" alt="Logo" />
        </Link>

        <button
          className={`navbar-burger ${isActive ? 'is-active' : ''}`}
          aria-label="menu"
          aria-expanded={isActive}
          onClick={() => setIsActive(!isActive)}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div className={`navbar-menu ${isActive ? 'is-active' : ''}`}>
        <div
          className="navbar-start"
          style={{ flexGrow: 1, justifyContent: 'center', display: 'flex' }}
        >
          <div className="navbar-item has-dropdown is-hoverable">
            <a className="navbar-link" style={{ fontSize: 17 }}>
              Select Central Bank
            </a>
            <div className="navbar-dropdown multi-column">
              {BANKS.map((bank) => (
                <Link key={bank.abbr} to={bank.href} className="navbar-item">
                  <img
                    src={`/static/images/flags/${bank.abbr}.png`}
                    alt={bank.abbr}
                    style={{
                      marginRight: '8px',
                      height: '16px',
                      border: '1px solid #000',
                      padding: '1px',
                    }}
                  />
                  {bank.abbr}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-body">
          <div className="container is-max-desktop">
            <div className="columns is-centered">
              <div className="column has-text-centered">
                <h1 className="title is-1 publication-title">Words That Unite The World: A Unified Framework for Deciphering Central Bank Communications Globally</h1>
                <AuthorList />
                <div className="is-size-5 mt-2 publication-authors">
  <div className="author-block flex flex-col items-center text-center">
    <div className="flex items-center gap-2">
      <img
        src="/static/logos/buzz_logo.png"
        alt="Georgia Institute of Technology"
        className="h-7 w-auto object-contain"
      />
      <span>Georgia Institute of Technology</span>
    </div>
  </div>
</div>

                <div className="is-size-6 publication-authors">
  <div className="author-block flex mt-2 flex-col items-center text-center">

    <div className="flex flex-wrap justify-center items-center gap-4">
      <span className="flex items-center gap-2">
        <img
          src="/static/logos/stanford.png"
          alt="Stanford University"
          className="h-5 w-auto object-contain"
        />
        <span>Stanford University</span>
      </span>

      <span className="flex items-center gap-2">
        <img
          src="/static/logos/duke.png"
          alt="Duke University"
          className="h-4 w-auto object-contain"
        />
        <span>Duke University</span>
      </span>

      <span className="flex items-center gap-2">
        <img
          src="/static/logos/MSFT.png"
          alt="Microsoft Corp."
          className="h-5 w-auto object-contain"
        />
        <span>Microsoft Corp.</span>
      </span>
    </div>
  </div>
</div>

                <div className="column has-text-centered">
                  <div className="publication-links">
                    <span className="link-block mr-2">
                      <a
                        href="/static/pdf/main.pdf"
                        className="external-link button is-normal is-rounded is-dark"
                      >
                        <span className="icon">
                          <i className="fas fa-file-pdf"></i>
                        </span>
                        <span>Paper</span>
                      </a>
                    </span>
                    <span className="link-block mr-2">
                      <a
                        href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=5259866"
                        className="external-link button is-normal is-rounded is-dark"
                      >
                        <span className="icon">
                          <i className="ai ai-ssrn"></i>
                        </span>
                        <span>SSRN</span>
                      </a>
                    </span>
                    <span className="link-block mr-2">
                      <a
                        href="https://arxiv.org/abs/2505.17048"
                        className="external-link button is-normal is-rounded is-dark"
                      >
                        <span className="icon">
                          <i className="ai ai-arxiv"></i>
                        </span>
                        <span>arXiv</span>
                      </a>
                    </span>
                    <span className="link-block mr-2">
                      <a
                        href="https://huggingface.co/collections/gtfintechlab/wcb-678965e38178c63158b45fdf"
                        className="external-link button is-normal is-rounded is-dark"
                      >
                        <span>🤗 </span>
                        <span>Dataset</span>
                      </a>
                    </span>
                    <span className="link-block mr-2">
                      <a
                        href="https://github.com/gtfintechlab/WorldCentralBanks"
                        className="external-link button is-normal is-rounded is-dark"
                      >
                        <span className="icon">
                          <i className="fab fa-github"></i>
                        </span>
                        <span>Code</span>
                      </a>
                    </span>

                    <span className="link-block">
                      <a
                        href="https://neurips.cc/virtual/2025/poster/121548"
                        className="external-link button is-normal is-rounded is-dark"
                      >
                        <span className="icon">
                          <i className="fas fa-brain"></i>
                        </span>
                        <span>NeurIPS</span>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div style={{marginTop: '-100px'}}>
      <MapSection setTooltipContent={setContent} centralBankPins={centralBankPins}/>
      <ReactTooltip html={true}>{content}</ReactTooltip>
    </div>

     {/* Marquee Section */}
     <section className="hero is-light is-small">
  <div className="hero-body">
    <div className="marquee-outer">
      <div className="marquee-inner">
        {[...Array(2)].flatMap(() =>
          [
            'FOMC', 'PBoC', 'BoJ', 'BoE', 'SNB', 'BCB', 'RBI', 'ECB', 'CBR', 'CBCT',
            'MAS', 'BoK', 'RBA', 'BoI', 'BoC', 'BdeM', 'NBP', 'CBRT', 'BoT', 'CBE',
            'BNM', 'BSP', 'CBoC', 'BCRP', 'BanRep'
          ].map((code, i) => (
            <div key={`${code}-${i}`} className="flag">
             <img
               src={`/static/images/flags/${code}.png`}
               alt={code}
               style={{
                 height: '120px',
                 border: '1px solid #333',      // thin dark border
                 borderRadius: '2px',           // slight rounding
                 boxSizing: 'border-box'        // ensures border inside sizing
               }}
             />
            </div>
          ))
        )}
      </div>
    </div>
  </div>
</section>

      {/* Abstract Section */}
      <section className="section">
        <div className="container is-max-desktop">
          <div className="columns is-centered has-text-centered">
            <div className="column is-four-fifths">
              <h2 className="title is-3">Abstract</h2>
              <div className="content has-text-justified">
                <p className='text-center'>
                Central banks around the world play a crucial role in maintaining economic stability. Deciphering policy implications in their communications is essential, especially as misinterpretations can disproportionately impact vulnerable populations. To address this, we introduce the World Central Banks (WCB) dataset, the most comprehensive monetary policy corpus to date, comprising over 380k sentences from 25 central banks across diverse geographic regions, spanning 28 years of historical data. After uniformly sampling 1k sentences per bank (25k total) across all available years, we annotate and review each sentence using dual annotators, disagreement resolutions, and secondary expert reviews. We define three tasks: Stance Detection, Temporal Classification, and Uncertainty Estimation, with each sentence annotated for all three. We benchmark seven Pretrained Language Models (PLMs) and nine Large Language Models (LLMs) (Zero-Shot, Few-Shot, and with annotation guide) on these tasks, running 15,075 benchmarking experiments. We find that a model trained on aggregated data across banks significantly surpasses a model trained on an individual bank's data, confirming the principle <i>"the whole is greater than the sum of its parts."</i> Additionally, rigorous human evaluations, error analyses, and predictive tasks validate our framework's economic utility. Our artifacts are accessible through the Webpage, HuggingFace, and GitHub under the CC-BY-NC-SA 4.0 license.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container is-max-desktop" style={{ textAlign: 'center' }}>
          <h2 className="title" style={{marginBottom: 0}}>Summary Performance of Fine-Tuned Models</h2>
          <br />
          
          <StanceTable />

        </div>
      </section>

      {/* BibTeX Section */}
      <section className="section" id="BibTeX">
        <div className="container is-max-desktop content">
          <h2 className="title">BibTeX</h2>
          <pre>
            <code>
              {`@article{shah2025wordsuniteworldunified,
      title={Words That Unite The World: A Unified Framework for Deciphering Central Bank Communications Globally},
      author={Agam Shah and Siddhant Sukhani and Huzaifa Pardawala and Saketh Budideti and Riya Bhadani and Rudra Gopal and Siddhartha Somani and Michael Galarnyk and Soungmin Lee and Arnav Hiray and Akshar Ravichandran and Eric Kim and Pranav Aluru and Joshua Zhang and Sebastian Jaskowski and Veer Guda and Meghaj Tarte and Liqin Ye and Spencer Gosden and Rutwik Routu and Rachel Yuh and Sloka Chava and Sahasra Chava and Dylan Patrick Kelly and Aiden Chiang and Harsit Mittal and Sudheer Chava},
      year={2025},
      eprint={2505.17048},
      archivePrefix={arXiv},
      primaryClass={cs.CL},
url={https://arxiv.org/abs/2505.17048},
}`}
            </code>
          </pre>
        </div>
      </section>

      {/* Disclaimer Section */}
<section className="section has-background-light" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
  <div className="container is-max-desktop content">
    <h2 className="title is-3 has-text-centered is-flex is-align-items-center is-justify-content-center mb-6">
      <span className="icon has-text-warning mr-3" style={{ fontSize: '1.5rem' }}>
        <i className="fas fa-exclamation-triangle"></i>
      </span>
      Disclaimer
    </h2>

    {/* Geopolitical Disclaimer */}
    <div
      className="box"
      style={{
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.06)',
        marginBottom: '2.5rem',
      }}
    >
      <h3 className="title is-5 has-text-danger mb-4">🌍 Geopolitical Disclaimer</h3>
      <p style={{ fontSize: '1.05rem', lineHeight: '1.75' }}>
        All references to country names, territories, flags, boundaries, or other geopolitical identifiers are
        drawn solely from publicly available sources—principally datasets and publications produced by
        international organizations such as the International Monetary Fund (IMF), the World Bank, and the
        United Nations. Their inclusion is strictly for descriptive or analytical purposes.
      </p>
      <ul className="mt-4" style={{ listStyleType: 'disc', marginLeft: '1.5rem', lineHeight: '1.7' }}>
        <li>We do not endorse or oppose any political stance, territorial claim, or status.</li>
        <li>
          We express no opinion on the legal status of any country, city, or region, nor its boundaries.
        </li>
        <li>
          This work does not imply recognition or approval of any government's policies or positions.
        </li>
      </ul>
    </div>

    {/* Financial Disclaimer */}
    <div
      className="box"
      style={{
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.06)',
      }}
    >
      <h3 className="title is-5 has-text-link mb-4">💼 Financial Disclaimer</h3>
      <p style={{ fontSize: '1.05rem', lineHeight: '1.75' }}>
        The analyses and interpretations presented in this paper are for academic discussion only. They do
        not constitute official economic policy advice, legal guidance, or recommendations for action.
        Readers should exercise their own judgment before making decisions based on the information herein.
      </p>
    </div>
  </div>
</section>



      {/* Acknowledgments Section */}
      <section className="section">
        <div className="container is-max-desktop">
          <h2 className="title is-3" style={{ textAlign: 'center' }}>
            Acknowledgments
          </h2>
          <div className="content text-center">
            <p>
            We would like to thank all the annotators who annotated the sentences and contributed to initial drafts of the annotation guides. We also appreciate the Georgia Tech Library for giving us access to the Bloomberg Terminal, Georgia Tech’s Office of Technology, Partnership for an Advanced Computing Environment (PACE) at Georgia Tech, and Label Studio. 
            </p>
            <p>
            This website is licensed under a <a rel="license"
                                                href="http://creativecommons.org/licenses/by-sa/4.0/" className='author-link'>Creative
            Commons Attribution-ShareAlike 4.0 International License</a>.
          </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home